import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../components/Icon";
import { useAuth } from "../context/AuthContext";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@shadcn-in-nx/ui/dialog";

const PRIVATE_COST = 300;

export default function CreateCommunityIntegrationModal({ onClose, onStart }) {
    const { t } = useTranslation();
    const { user } = useAuth();
    const [visibility, setVisibility] = React.useState("public");

    const creditBalance = user?.company?.credits?.find((c) => c.platform === "agentui")?.credits || 0;
    const canGoPrivate = creditBalance >= PRIVATE_COST;

    return (
        <Dialog open onOpenChange={() => onClose()}>
            <DialogContent className="max-w-lg">
                <DialogHeader>
                    <DialogTitle>{t("communityIntegrations.createModal.title")}</DialogTitle>
                </DialogHeader>
                <p className="text-sm text-gray-600">{t("communityIntegrations.createModal.subtitle")}</p>
                <div className="grid grid-cols-2 gap-3">
                    <button
                        onClick={() => setVisibility("public")}
                        className={`p-4 rounded-lg border-2 text-left transition-colors ${visibility === "public" ? "border-green-500 bg-green-50" : "border-gray-200 hover:border-gray-300"}`}
                    >
                        <Icon name="Globe" className="w-6 h-6 text-green-600 mb-2" />
                        <p className="font-semibold text-sm">{t("communityIntegrations.createModal.public")}</p>
                        <p className="text-xs text-gray-500 mt-1">{t("communityIntegrations.createModal.publicDesc")}</p>
                    </button>
                    <button
                        onClick={() => canGoPrivate && setVisibility("private")}
                        className={`p-4 rounded-lg border-2 text-left transition-colors ${!canGoPrivate ? "opacity-50 cursor-not-allowed" : ""} ${visibility === "private" ? "border-amber-500 bg-amber-50" : "border-gray-200 hover:border-gray-300"}`}
                    >
                        <Icon name="Lock" className="w-6 h-6 text-amber-600 mb-2" />
                        <p className="font-semibold text-sm">{t("communityIntegrations.createModal.private")}</p>
                        <p className="text-xs text-gray-500 mt-1">{t("communityIntegrations.createModal.privateDesc", { cost: PRIVATE_COST })}</p>
                        {!canGoPrivate && <p className="text-xs text-red-500 mt-1 font-medium">{t("communityIntegrations.createModal.notEnoughCredits")}</p>}
                    </button>
                </div>
                {visibility === "public" && (
                    <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-sm text-green-800">
                        {t("communityIntegrations.createModal.publicInfo")}
                    </div>
                )}
                {visibility === "private" && (
                    <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-800">
                        {t("communityIntegrations.createModal.privateInfo", { cost: PRIVATE_COST })}
                    </div>
                )}
                <button
                    onClick={() => onStart(visibility)}
                    className="w-full py-2 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 font-medium"
                >
                    {t("communityIntegrations.createModal.continue")}
                </button>
            </DialogContent>
        </Dialog>
    );
}
